module.exports = __webpack_public_path__ + "img/icon-home-notice-arrow.cb391fc8.svg";